import React from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';

export default function NotFoundPage() {
  return (
    <>
      <SeoHead
        title="Siden blev ikke fundet (404)"
        description="Den side du leder efter findes desværre ikke eller er blevet flyttet. Find vej tilbage til forsiden eller udforsk vores cases."
      />

      <section className="min-h-[80vh] flex items-center justify-center pt-32 pb-20 bg-[#FAF8F5]">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 text-center space-y-8">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#EAE4DC] text-xs font-bold uppercase tracking-widest text-[#4A4640]">
            <span>Fejl 404</span>
          </div>

          <div className="space-y-3">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#161514]">
              Siden blev ikke fundet
            </h1>
            <p className="text-base sm:text-lg text-[#5C5852] max-w-lg mx-auto leading-relaxed">
              Vi beklager, men den side du leder efter, er enten flyttet, slettet eller findes ikke.
            </p>
          </div>

          {/* Navigationsmuligheder */}
          <div className="p-6 rounded-3xl bg-white border border-[#E5DFD6] shadow-xs max-w-md mx-auto space-y-4">
            <p className="text-xs uppercase tracking-widest text-[#8C867D] font-semibold">
              Hurtige links
            </p>
            <div className="grid grid-cols-2 gap-2 text-sm">
              <Link
                to="/ydelser"
                className="p-2.5 rounded-xl bg-[#FAF8F5] hover:bg-[#EAE4DC] text-[#161514] font-medium transition-colors"
              >
                Vores ydelser
              </Link>
              <Link
                to="/cases"
                className="p-2.5 rounded-xl bg-[#FAF8F5] hover:bg-[#EAE4DC] text-[#161514] font-medium transition-colors"
              >
                Se cases
              </Link>
              <Link
                to="/saadan-arbejder-vi"
                className="p-2.5 rounded-xl bg-[#FAF8F5] hover:bg-[#EAE4DC] text-[#161514] font-medium transition-colors"
              >
                Sådan arbejder vi
              </Link>
              <Link
                to="/om-os"
                className="p-2.5 rounded-xl bg-[#FAF8F5] hover:bg-[#EAE4DC] text-[#161514] font-medium transition-colors"
              >
                Om os
              </Link>
            </div>
          </div>

          <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-[#161514] text-white font-semibold text-sm hover:bg-[#2A2926] transition-colors shadow-xs"
            >
              <i className="fa-regular fa-arrow-left text-xs" aria-hidden="true" />
              <span>Gå til forsiden</span>
            </Link>
            <Link
              to="/booking"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-[#EAE4DC] text-[#161514] font-semibold text-sm hover:bg-[#DDD6CC] transition-colors"
            >
              <span>Book en samtale</span>
              <i className="fa-regular fa-arrow-right text-xs" aria-hidden="true" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
